import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { THEMES, applyTheme, getStoredTheme } from "@/lib/theme";

export const ThemeSwitcher = () => {
  const [theme, setTheme] = useState(getStoredTheme());
  useEffect(() => {
    const h = (e) => setTheme(e.detail);
    window.addEventListener("theme-change", h);
    return () => window.removeEventListener("theme-change", h);
  }, []);
  const change = (t) => {
    applyTheme(t);
    api.patch("/auth/theme", { theme: t }).catch(() => {});
  };
  return (
    <div className="flex items-center gap-2.5" data-testid="theme-switcher">
      {THEMES.map((t) => (
        <button
          key={t.id}
          title={t.label}
          aria-label={`Тема: ${t.label}`}
          onClick={() => change(t.id)}
          data-testid={`theme-${t.id}`}
          className={`w-6 h-6 rounded-full border border-border transition-all duration-200 ${
            theme === t.id ? "ring-2 ring-primary ring-offset-2 ring-offset-background scale-110" : "opacity-60 hover:opacity-100 hover:scale-105"
          }`}
          style={{ background: t.swatch }}
        />
      ))}
    </div>
  );
};
